<ion-list *ngIf="!isLoading && (showTrackMileageInput || showOdometerValueInput)" [formGroup]="formGroup">
  <ion-item *ngIf="showTrackMileageInput" lines="none">
    <ion-label mode="ios" position="stacked">Have you been asked to track your mileage?</ion-label>
    <ion-segment toBoolean mode="ios" formControlName="trackMileage" (ionChange)="onTrackMileageChange($event)">
      <ion-segment-button [value]="true">Yes</ion-segment-button>
      <ion-segment-button [value]="false">No</ion-segment-button>
    </ion-segment>
    <ion-note class="error-message" *ngFor="let error of getErrors(formGroup.controls.trackMileage)">{{ error }}</ion-note>
  </ion-item>

  <ion-item *ngIf="showOdometerValueInput" lines="none" class="odometer-reading" (ionChange)="onOdometerValueChange($event)">
    <ion-label mode="ios" position="stacked">Odometer Reading</ion-label>
    <ion-input mode="ios" formControlName="odometerValue" type="number" min="0"></ion-input>
    <ion-note class="error-message" *ngFor="let error of getErrors(formGroup.controls.odometerValue)">{{ error }}</ion-note>
    
  </ion-item>
  <ion-item *ngIf="showOdometerValueInput" lines="none" class="odometer-photo">
    <ion-label mode="ios" position="stacked">Odometer Photo</ion-label>
    <app-image-selector-ui
      [viewOnlyMode]="false"
      [loading]="false"
      [sliderOptions]="sliderOptions"
      [photos]="odometerPhotoVm ? [odometerPhotoVm] : []"
      [tags]="[]"
      [captureInProgress]="isCapturingPhoto"
      [isDisabled]="!!odometerPhotoVm"
      [showAddCard]="!odometerPhotoVm"
      addLabel="Add"
      [enableEdit]="false"
      [enableRemove]="true"
      (captureRequested)="onOdometerPhotoCaptureRequested()"
      (removeRequested)="onOdometerPhotoRemoveRequested($event.photo, $event.event)"
      (editRequested)="onOdometerPhotoCaptureRequested()">
    </app-image-selector-ui>
  </ion-item>
</ion-list>
